/**
 * @file Automatically generated by barrelsby.
 */

export * from './widget.module';
export * from './widget';
